// src/pages/attendance/utils/attendanceHelpers.js
import { CheckCircle, AlertCircle, XCircle, Clock } from "lucide-react";

export const formatTimeForDisplay = (timeString, language) => {
  if (!timeString || timeString === "-" || timeString === "undefined") return "--:--";
  try {
    const locale = language === "ar" ? "ar-EG" : "en-US";
    const d = new Date(timeString);
    if (!isNaN(d.getTime())) return d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: true });
    return timeString;
  } catch { return "--:--"; }
};

export const calculateWorkingHours = (checkIn, checkOut) => {
  if (!checkIn || !checkOut || checkIn === "-" || checkOut === "-") return "--";
  try {
    const diff = new Date(checkOut) - new Date(checkIn);
    const hours = diff / (1000 * 60 * 60);
    return hours > 0 ? hours.toFixed(1) : "--";
  } catch { return "--"; }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "present": return CheckCircle;
    case "late":    return AlertCircle;
    case "absent":  return XCircle;
    default:        return Clock;
  }
};

export const getStatusColor = (status, colors) => {
  switch (status) {
    case "present": return colors.success;
    case "late":    return colors.warning;
    case "absent":  return colors.danger;
    default:        return colors.textMuted;
  }
};

export const getStatusText = (status, t) => t.status[status] || status;

// ==================== STATUS BADGE STYLING (from Attendance.js) ====================
export const getStatusBadgeStyle = (status) => {
  const baseStyle = {
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textAlign: "center",
    display: "inline-block",
  };

  switch (status) {
    case "present":
      return { ...baseStyle, background: "#b9fbc0", color: "#087e2a" }; // fresh green
    case "absent":
      return { ...baseStyle, background: "#ffd6d6", color: "#d7263d" }; // modern red
    case "late":
      return { ...baseStyle, background: "#fff2cc", color: "#b26a00" }; // gold yellow
    case "rest_day":
    case "Rest Day":
      return { ...baseStyle, background: "#e0e7ff", color: "#3730a3" }; // soft blue
    case "holiday":
      return { ...baseStyle, background: "#ffe0f0", color: "#c026d3" }; // pink
    case "On Leave":
    case "leave":
    case "onLeave":
      return { ...baseStyle, background: "#d1c4e9", color: "#512da8" }; // lavender purple
    case "half_day":
      return { ...baseStyle, background: "#ffe4b5", color: "#b45309" }; // light orange
    default:
      return { ...baseStyle, background: "#e0e7ef", color: "#334155" };
  }
};

export const formatTime = (date, language) =>
  date.toLocaleTimeString(language === "ar" ? "ar-EG" : "en-US", {
    hour12: true, hour: "2-digit", minute: "2-digit", second: "2-digit",
  });

export const formatDate = (date, language) =>
  date.toLocaleDateString(language === "ar" ? "ar-EG" : "en-US", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });